import computeInterviewPayload from '@Application/Beneficiaries/Interviews/Actions/computeInterviewPayload';
import type {
	ComputedInterviewPayload,
	InterviewPayload,
} from '@Application/Beneficiaries/Interviews/Actions/interviewsFetched';

export type InterviewCreatedAction = {
	type: 'INTERVIEW_CREATED';
	payload: ComputedInterviewPayload;
	typeKey: string;
	subjectId: number;
};

/**
 * Applies `computeInterviewPayload` here, in the action creator, following the motif already set by
 * `interviewFetched`/`interviewsFetched` — never in a store handler, which would make this one action
 * the exception in a layer whose point is uniformity.
 */
export default (payload: InterviewPayload, typeKey: string, subjectId: number): InterviewCreatedAction => ({
	type: 'INTERVIEW_CREATED',
	payload: computeInterviewPayload(payload),
	typeKey,
	subjectId,
});
